import { AppConstant } from "../reducers";

const GetApp = () => async (dispatch) => {
	dispatch({ type: "", item: {} });
};

const SetPageTitle = (title) => async (dispatch) => {
	dispatch({ type: AppConstant.SET_PAGE_TITLE, title })
};

export const AppAction = {
	GetApp,
	SetPageTitle,
};
